import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import { Auth } from 'aws-amplify';
import { LeftGrid, PrintButtonGrid } from '../../Episode.Styled';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useForm } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import {
  EPISODE_ORAS_CST,
  EPISODE_ORAS_CST_DELETE_URL,
  formDateFormat
} from '../../../../constants';
import { getStopApi, postStopApi, deleteStopApi } from '../../../../services/StopApi/StopApi';
import { getContactByUser } from '../../../Contact/services/contactsApi';
import FormInputText from '../../../common/Forms/FormTextField';
import FormInputDropdown from '../../../common/Forms/FormDropdown';
import moment from 'moment';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import FormInputMultiCheckbox from '../../../common/Forms/FormCheckbox';
import FormInputRadio from '../../../common/Forms/FormRadio';
import CSTScoringGuide from './CSTScoringGuide';
import ScoringTool from '../../../../rptOrasCST_Scoring.pdf'

const CST = () => {
	const [openCSTScoringGuide, setOpenCSTScoringGuide] = useState(false);
	const [user, setUser] = useState(null);
	const [oras, setOras] = useState(null);
	const [isOverride, setIsOverride] = useState(false);
	const [overrideLevel, setOverrideLevel] = useState();
	const [successMessage, setSuccessMessage] = useState(false);
	const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
	const episode = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]
  );
  //console.log('### episode');
  //console.log(episode);

  const participantInfo = useSelector(
    (state) => state?.participants?.participantsDetail[0]
  );
  //console.log('### participantInfo');
  //console.log(participantInfo);

  const aorcmReferenceData = useSelector((state) => state.aorcmReferenceData);
  //console.log('### aorcmReferenceData');
  //console.log(aorcmReferenceData);

  const [tot1, setTot1] = useState();
  const [tot2, setTot2] = useState();
  const [tot3, setTot3] = useState();
  const [tot4, setTot4] = useState();
  const [tot5, setTot5] = useState();
  const [tot6, setTot6] = useState();
  const [tot7, setTot7] = useState();
  const [totCST, setTotCST] = useState();

  const defaultValues = {
    q1_1: '',
    q1_2: '',
    q1_3: '',
    q1_4: '',
    q1_5: '',
    q1_6: '',
    q2_1: '',
    q2_2: '',
    q2_3: '',
    q2_4: '',
    q2_5: '',
    q2_6: '',
    q3_1: '',
    q3_2: '',
    q3_3: '',
    q3_4: '',
    q3_5: '',
    q4_1: '',
    q4_2: '',
    q5_1: '',
    q5_2: '',
    q5_3: '',
    q5_4: '',
    q5_5: '',
    q6_1: '',
    q6_2: '',
    q6_3: '',
    q6_4: '',
    q7_1: '',
    q7_2: '',
    q7_3: '',
    q7_4: '',
    q7_5: '',
    q7_6: '',
    q7_7: '',
    epdOrasAssessDate: null,
    epdOrasCSSID: null,
    isOverride: false,
    other_LowIntelligence: false,
    other_PhysicalHandicap: false,
    other_ReadWriteLimits: false,
    other_MentalHealth: false,
    other_NoDesire: false,
    other_Transportation: false,
    other_ChildCare: false,
    other_Language: false,
    other_Ethnicity: false,
    other_Cultural: false,
    other_HistoryAbuse: false,
    other_Interpersonal: false,
    other_Other: false,
    other_OtherDescr: null,

  }

	const { register, getValues, watch, handleSubmit, reset, control, formState: { errors } } = useForm({defaultValues: defaultValues});

	React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
    	//console.log(value)
    	setTot1(
    		Number(value.q1_1 ?? 0) + 
    		Number(value.q1_2 ?? 0) + 
    		Number(value.q1_3 ?? 0) + 
    		Number(value.q1_4 ?? 0) + 
    		Number(value.q1_5 ?? 0) + 
    		Number(value.q1_6 ?? 0)
      );
    	setTot2(
    		Number(value.q2_1 ?? 0) + 
    		Number(value.q2_2 ?? 0) + 
    		Number(value.q2_3 ?? 0) + 
    		Number(value.q2_4 ?? 0) + 
    		Number(value.q2_5 ?? 0) + 
    		Number(value.q2_6 ?? 0)
      );
    	setTot3(
    		Number(value.q3_1 ?? 0) + 
    		Number(value.q3_2 ?? 0) + 
    		Number(value.q3_3 ?? 0) + 
    		Number(value.q3_4 ?? 0) + 
    		Number(value.q3_5 ?? 0)
      );
    	setTot4(
    		Number(value.q4_1 ?? 0) + 
    		Number(value.q4_2 ?? 0) 
      );
    	setTot5(
    		Number(value.q5_1 ?? 0) + 
    		Number(value.q5_2 ?? 0) + 
    		Number(value.q5_3 ?? 0) + 
    		Number(value.q5_4 ?? 0) + 
    		Number(value.q5_5 ?? 0)
      );
    	setTot6(
    		Number(value.q6_1 ?? 0) + 
    		Number(value.q6_2 ?? 0) + 
    		Number(value.q6_3 ?? 0) + 
    		Number(value.q6_4 ?? 0)
      );
    	setTot7(
    		Number(value.q7_1 ?? 0) + 
    		Number(value.q7_2 ?? 0) + 
    		Number(value.q7_3 ?? 0) + 
    		Number(value.q7_4 ?? 0) + 
    		Number(value.q7_5 ?? 0) + 
    		Number(value.q7_6 ?? 0) + 
    		Number(value.q7_7 ?? 0)
      );
      setTotCST(
    		Number(value.q1_1 ?? 0) + 
    		Number(value.q1_2 ?? 0) + 
    		Number(value.q1_3 ?? 0) + 
    		Number(value.q1_4 ?? 0) + 
    		Number(value.q1_5 ?? 0) + 
    		Number(value.q1_6 ?? 0) +
    		Number(value.q2_1 ?? 0) + 
    		Number(value.q2_2 ?? 0) + 
    		Number(value.q2_3 ?? 0) + 
    		Number(value.q2_4 ?? 0) + 
    		Number(value.q2_5 ?? 0) + 
    		Number(value.q2_6 ?? 0) +
    		Number(value.q3_1 ?? 0) + 
    		Number(value.q3_2 ?? 0) + 
    		Number(value.q3_3 ?? 0) + 
    		Number(value.q3_4 ?? 0) + 
    		Number(value.q3_5 ?? 0) +
    		Number(value.q4_1 ?? 0) + 
    		Number(value.q4_2 ?? 0) +
    		Number(value.q5_1 ?? 0) + 
    		Number(value.q5_2 ?? 0) + 
    		Number(value.q5_3 ?? 0) + 
    		Number(value.q5_4 ?? 0) + 
    		Number(value.q5_5 ?? 0) +
    		Number(value.q6_1 ?? 0) + 
    		Number(value.q6_2 ?? 0) + 
    		Number(value.q6_3 ?? 0) + 
    		Number(value.q6_4 ?? 0) +
    		Number(value.q7_1 ?? 0) + 
    		Number(value.q7_2 ?? 0) + 
    		Number(value.q7_3 ?? 0) + 
    		Number(value.q7_4 ?? 0) + 
    		Number(value.q7_5 ?? 0) + 
    		Number(value.q7_6 ?? 0) + 
    		Number(value.q7_7 ?? 0)
      );

    });	
     return () => subscription.unsubscribe();
  }, [watch]);

	const onFormSubmit = (payload) => {
		const url = `${EPISODE_ORAS_CST}`;
  	const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

  	//console.log(payload)
  	payload.EpdID = episode.episodeID;
  	postStopApi({ url, payload, authorization }).then((response) => {
  		fetchData();
  		setSuccessMessage(true)
  	}).catch((e) => alert(e));
	}
	
  const closeSuccessMessage = () => setSuccessMessage(false);

	const onErrors = () => {
    alert('Unable to Save. Please check for field validation errors.')
  }

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this ORAS CST record?')) {
      return;
    }

    const url = `${EPISODE_ORAS_CST_DELETE_URL}/${oras.epdOrasCSTID}`;
    const payload = {};
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

    deleteStopApi({ url, payload, authorization })
      .then((response) => {
        console.log('### delete response');
        console.log(response);
        // Clear form and return to add mode
        setOras(null);
        reset(defaultValues);
        setIsOverride(false);
        setOverrideLevel(null);
        setSuccessMessage(true);
      })
      .catch((e) => alert(e));
  };

	useEffect(() => {
    const initUser = async () => {
      const userData = await getUser();
      setUser(userData);
    };

    if (!user) {
      initUser();
    } else if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
  }, [
    user,
  ]);

  const fetchData = async () => {
    const commonParams = `${EPISODE_ORAS_CST}/${episode.episodeId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const response = await getStopApi({ commonParams, authorization });
    //console.log(response)
    if (response?.data) {
     	const orasData = {
     									...response.data,
     									epdOrasAssessDate: response.data.epdOrasAssessDate ? moment(response.data.epdOrasAssessDate).format(formDateFormat) : '',

     							 };
     	setOras(orasData);
     	setIsOverride(orasData.isOverride);
     	setOverrideLevel(orasData.overrideLevel);
      //console.log('### CST orasData')
     	//console.log(orasData)
     	reset(orasData);

    }
  };

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      try {
        const loggedInContact = await getContactByUser(user);
        user.contact = loggedInContact;
      } catch (error) {
        console.log('Error fetching contact');
      }
      return user;
    } catch (error) {
      console.log('Not signed in');
      return null;
    }
  };

	return (
  	<>
    	<PrintButtonGrid container>
      	<Grid item>
          	<Box pt={2}>
              {user?.contact?.authLock === true && oras?.epdOrasCSTID && (
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                >
                  Delete
                </Button>
              )}
              &nbsp;
            	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before printing');		
              			}
              			else {
              				handlePrint();
              			}
              		}}
            	>
              		Print
            	</Button>&nbsp;
            	<a
				        href={ScoringTool}
				        download="Scoring Tool"
				        target="_blank"
				        rel="noreferrer"
				      >
	            	<Button
	              		variant="contained"
	            	>
	              		Scoring Tool
	            	</Button>
	            </a>&nbsp;	
            	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before entering scoring guide')			
              			}
              			else {
              				handleSubmit(onFormSubmit, onErrors)();
                			setOpenCSTScoringGuide(true);
                		}	
              		}}
            	>
              		Scoring Guide
            	</Button>
          	</Box>
      	</Grid>
    	</PrintButtonGrid>

      <form onSubmit={handleSubmit(onFormSubmit, onErrors)}>
	    	<Box pt={4} px={8} ref={componentRef}>  
		      

        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Box style={{ alignItems: 'center' }}>
              <Typography variant="h4" align="center">
                ORAS Scoring for the Community Supervision Tool CST
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={7}>
            <Typography variant='h5'>Name: {participantInfo.key}</Typography>
          </Grid>
          <LeftGrid item xs={12} sm={5}>
            <Typography variant="h5" align="center">
              Date of Assessment:
            </Typography>

						<FormInputText
              name="epdOrasAssessDate"
              type="date"
              control={control}
              label=""
              register={register('epdOrasAssessDate', { required: "Required" })}
            />
           	<Typography sx={{color: 'red'}}>{errors?.epdOrasAssessDate && errors.epdOrasAssessDate.message}</Typography>

          </LeftGrid>
          <Grid item xs={12} sm={6}>
            <Typography variant='h5'>CDC #: {episode.cDCNumber}</Typography>
          </Grid>
          <LeftGrid item xs={12} sm={6}>
            <Typography sx={{margin: '8px'}} variant="h5" align="center">
              Community Service Specialist:
            </Typography>

            <FormInputDropdown
              name="epdOrasCSSID"
              getIdValue={true}
              control={control}
              options={aorcmReferenceData?.caseManagerOrCMList}
              label=""
              register={register('epdOrasCSSID', { required: "Required" })}
            /> 	
           	<Typography sx={{color: 'red'}}>{errors?.epdOrasCSSID && errors.epdOrasCSSID.message}</Typography>

          
          </LeftGrid>
        </Grid>



		      {/** Criminal History **/}
		      <Box pt={0}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650 }} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>1.0 Criminal History</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.1 Most Serious Arrest Under Age 18
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - Yes, Misdemeanor'},
					              	{id: 2, value: '2 - Yes, Felony'},					              	
					              ]}
					              label=""
					              register={register('q1_1', { required: "Required" })}
					            /> 	

			              	<Typography sx={{color: 'red'}}>{errors?.q1_1 && errors.q1_1.message}</Typography>
			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.2 Number of Prior Adult Felony Convictions
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - One or Two'},
					              	{id: 2, value: '2 - Three or More'},					              	
					              ]}
					              label=""
					              register={register('q1_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_2 && errors.q1_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.3 Prior Sentence as an Adult to a Jail or Secure Correctional Facility
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q1_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_3 && errors.q1_3.message}</Typography>
			              	
			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.4 Received Official Misconduct while Incarcerated as an Adult
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q1_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_4 && errors.q1_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.5 Prior Sentence to Community Supervision as an Adult
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q1_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_5 && errors.q1_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	1.6 Community Supervision Ever Been Revoked for Technical Violation as an Adult
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q1_6"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q1_6', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q1_6 && errors.q1_6.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Criminal History</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot1 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>  


		      {/** Education, Employment and Financial Situation **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>2.0 Education, Employment and Financial Situation</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.1 Highest Education
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - High School Graduate or Higher'},
					              	{id: 1, value: '1 - Less than High School or GED'},
					              ]}
					              label=""
					              register={register('q2_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_1 && errors.q2_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.2 Ever Suspended or Expelled From School
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q2_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_2 && errors.q2_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.3 Employed at the Time of Arrest
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - No'},
					              ]}
					              label=""
					              register={register('q2_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_3 && errors.q2_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.4 Currently Employed/School
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes, Full-time, Disabled, or Retired'},
					              	{id: 1, value: '1 - Not Employed or Employed Part-time'},
					              ]}
					              label=""
					              register={register('q2_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_4 && errors.q2_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.5 Better Use of Time
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No, Most Time Structured'},
					              	{id: 1, value: '1 - Yes, Lots of free time'},
					              ]}
					              label=""
					              register={register('q2_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_5 && errors.q2_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	2.6 Current Financial Situation
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q2_6"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Stable/Minimal Problems'},
					              	{id: 1, value: '1 - Problems'},
					              ]}
					              label=""
					              register={register('q2_6', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q2_6 && errors.q2_6.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Education, Employment and Financial Situation</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot2 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Family and Social Support **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>3.0 Family and Social Support</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.1 Parents have Criminal Record
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q3_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_1 && errors.q3_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.2 Satisfied with Current Marital or Equivalent Situation
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - No'},
					              ]}
					              label=""
					              register={register('q3_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_2 && errors.q3_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.3 Emotional and Personal Support Available from Family or Others
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Very Strong Support'},
					              	{id: 1, value: '1 - None to Strong Support'},
					              ]}
					              label=""
					              register={register('q3_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_3 && errors.q3_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.4 Level of Satisfaction with Current Level of Support from Family or Others
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Very Satisfied'},
					              	{id: 1, value: '1 - Satisfied to Not Satisfied'},
					              ]}
					              label=""
					              register={register('q3_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_4 && errors.q3_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	3.5 Stability of Residence
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q3_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Stable'},
					              	{id: 1, value: '1 - Not Stable'},
					              ]}
					              label=""
					              register={register('q3_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q3_5 && errors.q3_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Family and Social Support</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot3 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Neighborhood **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>4.0 Neighborhood</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	4.1 High Crime Area
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q4_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q4_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q4_1 && errors.q4_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	4.2 Drugs Readily Available in Neighborhood
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q4_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No, Generally Not Available'},
					              	{id: 1, value: '1 - Yes, Somewhat Available'},
					              	{id: 2, value: '2 - Yes, Easily Available'},
					              ]}
					              label=""
					              register={register('q4_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q4_2 && errors.q4_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Neighborhood</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot4 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Substance Use **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>5.0 Substance Use</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	5.1 Age First Began Regularly Using Alcohol
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q5_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - 17 or Older'},
					              	{id: 1, value: '1 - Under Age 17'},
					              ]}
					              label=""
					              register={register('q5_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q5_1 && errors.q5_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	5.2 Most Recent Period of Abstinence from Alcohol:
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q5_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Within 6 Months or No Alcohol Problem'},
					              	{id: 1, value: '1 - Not Abstained in Last 6 Months'},
					              ]}
					              label=""
					              register={register('q5_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q5_2 && errors.q5_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	5.3 Ever Used Illegal Drugs
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q5_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q5_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q5_3 && errors.q5_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	5.4 Drug Use Caused Problems
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q5_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - Past'},
					              	{id: 2, value: '2 - Current'},
					              ]}
					              label=""
					              register={register('q5_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q5_4 && errors.q5_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	5.5 Drug Use Caused Problems with Employment
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q5_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q5_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q5_5 && errors.q5_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Substance Use</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot5 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Peer Associations **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>6.0 Peer Associations</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	6.1 Criminal Friends
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q6_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - None'},
					              	{id: 1, value: '1 - Some'},
					              	{id: 2, value: '2 - Majority'},
					              ]}
					              label=""
					              register={register('q6_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q6_1 && errors.q6_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	6.2 Contact with Past Criminal Peers
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q6_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No Contact'},
					              	{id: 1, value: '1 - At Risk of Contacting'},
					              	{id: 2, value: '2 - Contact or Actively Seeks Out'},
					              ]}
					              label=""
					              register={register('q6_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q6_2 && errors.q6_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	6.3 Gang Membership
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q6_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No, Never'},
					              	{id: 1, value: '1 - Yes, but Not Current'},
					              	{id: 2, value: '2 - Yes, Current'},
					              ]}
					              label=""
					              register={register('q6_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q6_3 && errors.q6_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	6.4 Criminal Activities
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q6_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Strong Identification'},
					              	{id: 1, value: '1 - Mixture of Pro- and Antisocial Activities'},
					              	{id: 2, value: '2 - Strong identification with criminal activities'},
					              ]}
					              label=""
					              register={register('q6_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q6_4 && errors.q6_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Peer Associations</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot6 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Criminal Thinking **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>7.0 Criminal Thinking</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}></TableCell>
			            </TableRow>
			          </TableHead>
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#747070'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Question</TableCell>
			              <TableCell align={'center'} sx={{color: '#fff', padding: '4px'}}>Score</TableCell>
			            </TableRow>
			          </TableHead>
			          <TableBody>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	7.1 Criminal Attitudes
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q7_1"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No/Limited'},
					              	{id: 1, value: '1 - Some Criminal Attitudes'},
					              	{id: 2, value: '2 - Significant Criminal Attitudes'},
					              ]}
					              label=""
					              register={register('q7_1', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q7_1 && errors.q7_1.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	7.2 Expresses Concern about Others
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q7_2"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Concerned about others'},
					              	{id: 1, value: '1 - Immediate Family/Friends'},
					              	{id: 2, value: '2 - No Concern'},
					              ]}
					              label=""
					              register={register('q7_2', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q7_2 && errors.q7_2.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	7.3 Feels Lack of Control Over Events
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q7_3"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Controls Events'},
					              	{id: 1, value: '1 - Sometimes Lacks Control'},
					              	{id: 2, value: '2 - Generally Lacks Control'},
					              ]}
					              label=""
					              register={register('q7_3', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q7_3 && errors.q7_3.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	7.4 Sees No Problem in Telling Lies
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q7_4"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - No'},
					              	{id: 1, value: '1 - Yes'},
					              ]}
					              label=""
					              register={register('q7_4', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q7_4 && errors.q7_4.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	7.5 Engages in Risk Taking Behavior
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q7_5"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Rarely Takes Risks'},
					              	{id: 1, value: '1 - Sometimes Takes Risks'},
					              	{id: 2, value: '2 - Generally Takes Risks'},
					              ]}
					              label=""
					              register={register('q7_5', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q7_5 && errors.q7_5.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#ceebfd'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	7.6 Walks Away from a Fight
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q7_6"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Yes'},
					              	{id: 1, value: '1 - Sometimes'},
					              	{id: 2, value: '2 - Rarely'},
					              ]}
					              label=""
					              register={register('q7_6', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q7_6 && errors.q7_6.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#fff'}}
			            >
			              <TableCell sx={{color: '#262626', padding: '4px'}}>
			              	7.7 Believes in “Do Unto Others Before They Do Unto You”
		
			              </TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
					            <FormInputDropdown
					              name="q7_7"
					              getIdValue={true}
					              control={control}
					              options={ [
					              	{id: 0, value: '0 - Disagree'},
					              	{id: 1, value: '1 - Sometimes'},
					              	{id: 2, value: '2 - Agrees'},
					              ]}
					              label=""
					              register={register('q7_7', { required: "Required" })}
					            /> 	
			              	<Typography sx={{color: 'red'}}>{errors?.q7_7 && errors.q7_7.message}</Typography>

			              </TableCell>
			            </TableRow>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell sx={{color: '#fff', padding: '4px'}}>Total Score for Criminal Thinking</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>
			              	{tot7 ?? 'N/A'}
			              </TableCell>
			            </TableRow>
			          </TableBody>
			        </Table>
			      </TableContainer>
			    </Box>

		      {/** Total **/}
			    <Box pt={4}>
			      <TableContainer component={Paper}>
			        <Table sx={{ minWidth: 650}} aria-label="simple table">
			          <TableHead>
			            <TableRow
			              sx={{backgroundColor: '#000'}}
			            >
			              <TableCell width={'70%'} sx={{color: '#fff', padding: '4px'}}>Total CST Score</TableCell>
			              <TableCell sx={{color: '#fff', padding: '4px'}}>{totCST}</TableCell>
			            </TableRow>
			          </TableHead>
			        </Table>
			      </TableContainer>

			      <Box pt={4}>
			      	<Grid container spacing={2}>
			      		<Grid item xs={6}>
					        <Typography variant="h5">
					          Calculated Risk: { participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
					          										(totCST ?? 0) == 0 ? '' :
					          										totCST < 15 ? 'Low' :
					          										totCST < 24 ? 'Moderate' :
					          										totCST < 34 ? 'High' :
					          										'Very High'
					          										:
					          										(totCST ?? 0) == 0 ? '' :
					          										totCST < 15 ? 'Low' :
					          										totCST < 22 ? 'Low Moderate' :
					          										totCST < 29 ? 'Moderate' :
					          										'High'

					          								 }
					        </Typography>
					        <Typography variant="h5">
					          Recommendations: { participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
						          									!isOverride ?
						          										(totCST ?? 0) == 0 ? '' :
						          										totCST < 15 ? 'LOW - Minimum supervision or non-reporting supervision' :
						          										totCST < 24 ? 'MODERATE - Regular supervision; programming should be provided for moderate and high need domains' :
						          										totCST < 34 ? 'HIGH - Enhanced supervision or residential placement; programming should be provided for moderate and high need domains' :
						          										'VERY HIGH - Residential placement preferred or enhanced supervision at highest level; programming should be provided for moderate and high need domains'
						          								 	:
						          								 		overrideLevel == 1 ? 'LOW - Minimum supervision or non-reporting supervision' :
						          										overrideLevel == 2  ? 'MODERATE - Regular supervision; programming should be provided for moderate and high need domains' :
						          										overrideLevel == 3  ? 'HIGH - Enhanced supervision or residential placement; programming should be provided for moderate and high need domains' :
						          										'VERY HIGH - Residential placement preferred or enhanced supervision at highest level; programming should be provided for moderate and high need domains'
						          								:
						          									!isOverride ?
						          										(totCST ?? 0) == 0 ? '' :
						          										totCST < 15 ? 'LOW - Minimum supervision or non-reporting supervision' :
						          										totCST < 22 ? 'LOW MODERATE - Regular supervision; programming should be provided for moderate and high need domains' :
						          										totCST < 29 ? 'MODERATE - Enhanced supervision or residential placement; programming should be provided for moderate and high need domains' :
						          										'HIGH - Residential placement preferred or enhanced supervision at highest level; programming should be provided for moderate and high need domains'
						          								 	:
						          								 		overrideLevel == 1 ? 'LOW - Minimum supervision or non-reporting supervision' :
						          										overrideLevel == 2  ? 'LOW MODERATE - Regular supervision; programming should be provided for moderate and high need domains' :
						          										overrideLevel == 3  ? 'MODERATE - Enhanced supervision or residential placement; programming should be provided for moderate and high need domains' :
						          										'HIGH - Residential placement preferred or enhanced supervision at highest level; programming should be provided for moderate and high need domains'

						          								}

					        </Typography>
					      </Grid>  
			      		<Grid item xs={6}>
			      			<FormInputMultiCheckbox
                    control={control}
                    name="isOverride"
                    label="Professional Override"
                    register={register('isOverride', {
                      onChange: (e) => {
                        setIsOverride(e.target.value);
                      },
                    })}
                  />
                  <FormInputText
	                  name='overrideReason'
	                  control={control}
	                  multiline={true}
	                  type="text"
	                  label='Override Reason'
	                  shrink={true}
	                  disabled={!isOverride}
	                />
	                <FormInputRadio
	                	isRadio={true}
	                  name='overrideLevel'
	                  control={control}
	                  options={ participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
	                  	[
	                  		{'value': 1, 'label': 'Low'},
	                  		{'value': 2, 'label': 'Moderate'},
	                  		{'value': 3, 'label': 'High'},
	                  		{'value': 4, 'label': 'Very High'}
	                  	]
	                  	:
	                  	[
	                  		{'value': 1, 'label': 'Low'},
	                  		{'value': 2, 'label': 'Low Moderate'},
	                  		{'value': 3, 'label': 'Moderate'},
	                  		{'value': 4, 'label': 'High'}
	                  	]


	                  }
	                  label='Override Level: &nbsp;'
	                  disabled={!isOverride}
	                  register={register('overrideLevel', {
                      onChange: (e) => {
                        setOverrideLevel(e.target.value);
                      },
                    })}
	                />
					      </Grid>
					        <Grid item xs={12}>
	                  <Typography variant="h6">
	                    Other areas of concern. Check all that apply:
	                  </Typography>
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_LowIntelligence"
	                    label="Low Intelligence"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_PhysicalHandicap"
	                    label="Physical Handicap"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_ReadWriteLimits"
	                    label="Read/Writing"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_MentalHealth"
	                    label="Mental Health"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_NoDesire"
	                    label="No Desite to Change"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Transportation"
	                    label="Transportation"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_ChildCare"
	                    label="Child Care"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Language"
	                    label="Language"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Ethnicity"
	                    label="Ethnicity"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Cultural"
	                    label="Cultural Barriers"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_HistoryAbuse"
	                    label="History of Abuse/Neglect"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Interpersonal"
	                    label="Interpersonal Anxiety"
	                  />
	                  <FormInputMultiCheckbox
	                    control={control}
	                    name="other_Other"
	                    label="Other"
	                  />
	                  <FormInputText
		                  name='other_OtherDescr'
		                  control={control}
		                  type="text"
		                  label='Other Area of Concern'
		                  multiline={true}
		                  shrink={true}
		                />		                
	                </Grid>  
  
				      </Grid>
			      </Box>
			    </Box>      

		    </Box>
		    <LeftGrid pt={4} px={8}>
		    			<Button type='submit' variant="contained">Save CST</Button>&nbsp;
            	{user?.contact?.authLock === true && oras?.epdOrasCSTID && (
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                >
                  Delete
                </Button>
              )}
              &nbsp;
            	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before printing');
              			}
              			else {
              				handlePrint();
              			}
              		}}
            	>
              		Print
            	</Button>&nbsp;
            	<a
				        href={ScoringTool}
				        download="Scoring Tool"
				        target="_blank"
				        rel="noreferrer"
				      >
	            	<Button
	              		variant="contained"
	            	>
	              		Scoring Tool
	            	</Button>
	            </a>&nbsp;	
            	<Button
              		variant="contained"
              		onClick={() => {
              			if (!oras) {
              				alert('Please save before entering scoring guide')			
              			}
              			else {
              				handleSubmit(onFormSubmit, onErrors)();
                			setOpenCSTScoringGuide(true);
                		}	
              		}}
            	>
              		Scoring Guide
            	</Button>
		    </LeftGrid>	  
		  </form>

	    <Snackbar 
	      open={successMessage} 
	      autoHideDuration={3000} 
	      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
	      onClose={closeSuccessMessage}
	    >
	      <Alert 
	  			severity="success"
	        onClose={closeSuccessMessage}
	      >
	      	Save Success!
	      </Alert>
	    </Snackbar>

	    <CSTScoringGuide
        open={openCSTScoringGuide}
        setOpen={setOpenCSTScoringGuide}
        participantInfo={participantInfo}
        episode={episode}
        aorcmReferenceData={aorcmReferenceData}
        oras={oras}
        tot1={tot1}
        tot2={tot2}
        tot3={tot3}
        tot4={tot4}
        tot5={tot5}
        tot6={tot6}
        tot7={tot7}
        totCST={totCST}
        isOverride={isOverride}
        overrideLevel={overrideLevel}
      />
  
		</>  	
  );	
};

export default CST;